import React, { useState, useEffect } from "react";

import EmbedCalendlyEvent from "components/embeds/calendly";
import {
  blockedCalendlyCountries,
  blockedCalendlyConfig
} from "utils/sharedDatasets";

import { PopupCalendlyEvent } from "../embeds/calendly";
import Calendar from "images/icons/calendar-icon.inline.svg";

const StatusCompCalendlyHeading = ({
  txtColor,
  iconColor,
  calendlyHeading,
  containerClass = "flex gap-3 items-center mt-10"
}) => (
  <>
    <div className={containerClass}>
      <Calendar className={`h-9 w-9 shrink-0 fill-white ${iconColor}`} />
      <h1
        className={`font-light shrink-0 ${txtColor}`}
        dangerouslySetInnerHTML={{
          __html: calendlyHeading ?? blockedCalendlyConfig.heading
        }}
      />
    </div>
  </>
);

const StatusCalendlyComp = ({
  status,
  calendlyLayout,
  iconColor,
  txtColor,
  calendlyHeading,
  calendlyDesc,
  isGold,
  setCalendlyOverlay,
  calendlyActive,
  calendlyPrefill
}) => {
  const [restrictedCountry, setRestrictedCountry] = useState(false);

  useEffect(() => {
    const analytics = JSON.parse(
      window?.localStorage.getItem("gvx-analytics") || "{}"
    );
    const country = analytics?.country;
    const isBlockedcountry = blockedCalendlyCountries.includes(country);
    setRestrictedCountry(isBlockedcountry);
  }, []);

  return (
    <>
      {restrictedCountry === false &&
        calendlyActive === true &&
        status !== "processing" && (
          <>
            {calendlyLayout === "popup" ? (
              <></>
            ) : (
              <>
                <StatusCompCalendlyHeading
                  iconColor={iconColor}
                  txtColor={txtColor}
                  calendlyHeading={calendlyHeading}
                />

                <div
                  className={`py-3 sm:pt-3 text-xl font-light ${txtColor}`}
                  dangerouslySetInnerHTML={{
                    __html: calendlyDesc ?? blockedCalendlyConfig.descText
                  }}
                />
              </>
            )}

            {calendlyLayout === "popup" ? (
              <>
                {isGold ? (
                  <PopupCalendlyEvent
                    {...blockedCalendlyConfig.gold}
                    headingTitle={
                      calendlyHeading ?? blockedCalendlyConfig.heading
                    }
                    headingBlock={
                      <StatusCompCalendlyHeading
                        iconColor={iconColor}
                        txtColor={txtColor}
                        calendlyHeading={calendlyHeading}
                        containerClass="flex gap-3 items-center mb-4"
                      />
                    }
                    description={
                      <div
                        className={`py-3 sm:pt-3 text-xl font-light ${txtColor}`}
                        dangerouslySetInnerHTML={{
                          __html: calendlyDesc ?? blockedCalendlyConfig.descText
                        }}
                      />
                    }
                    setCalendlyOverlay={setCalendlyOverlay}
                    prefill={calendlyPrefill}
                  />
                ) : (
                  <PopupCalendlyEvent
                    {...blockedCalendlyConfig.default}
                    headingTitle={
                      calendlyHeading ?? blockedCalendlyConfig.heading
                    }
                    headingBlock={
                      <StatusCompCalendlyHeading
                        iconColor={iconColor}
                        txtColor={txtColor}
                        calendlyHeading={calendlyHeading}
                        containerClass="flex gap-3 items-center mb-4"
                      />
                    }
                    description={
                      <div
                        className={`py-3 sm:pt-3 text-xl font-light ${txtColor}`}
                        dangerouslySetInnerHTML={{
                          __html: calendlyDesc ?? blockedCalendlyConfig.descText
                        }}
                      />
                    }
                    setCalendlyOverlay={setCalendlyOverlay}
                    prefill={calendlyPrefill}
                  />
                )}
              </>
            ) : (
              <>
                {isGold ? (
                  <EmbedCalendlyEvent
                    {...blockedCalendlyConfig.gold}
                    prefill={calendlyPrefill}
                  />
                ) : (
                  <EmbedCalendlyEvent
                    {...blockedCalendlyConfig.default}
                    prefill={calendlyPrefill}
                  />
                )}
              </>
            )}
          </>
        )}
    </>
  );
};
export default StatusCalendlyComp;
